import { UntypedItemComponent } from './app/item-page/simple/item-types/untyped-item/untyped-item.component';

export const ENTRY_COMPONENTS = [UntypedItemComponent];
